import { ConfirmationDialog } from "components";
import { CommercialUserStatus, ShowUserStatus } from "props/enum";
import { useState } from "react";
import { ErrorIcon } from "assets";
import { connect } from "react-redux";
import { updateDcddUserStatus } from "../state/action";
import { DcddUserProps, RegisteredDcddUserProps } from "../state/actionType";

interface OwnProps {
  onClose: () => void;
  dcddUserData: DcddUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateDcddStatus: React.FC<Props> = ({
  onClose,
  dcddUserData,
  onUpdateDcddUserStatus
}) => {
 const [error, setError] = useState("");

  const handleConfirm = async () => {
    const newStatus =
      dcddUserData?.status === CommercialUserStatus.Active
        ? CommercialUserStatus.Deleted
        : CommercialUserStatus.Active;

    try {
      await onUpdateDcddUserStatus(dcddUserData?.id.toString(), newStatus);
      onClose();
    } catch (err: any) {
      setError("Failed to update user status. Please try again.");
      console.error("Status update error:", err);
    }
  };
  return (
    <>
      <ConfirmationDialog
        isErrorIcon
        title={`Confirm your update`}
        subTitle={`${ dcddUserData?.user_profile?.name  }`}
        message={`Are you sure you want to ${
          dcddUserData?.status === ShowUserStatus.Active
            ? ShowUserStatus.Delete
            : ShowUserStatus.Active
        } this user?`}
        onCancel={onClose}
        error={error}
        onConfirm={handleConfirm}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateDcddUserStatus: (
    userID: string,
    status:string
  ) =>
    dispatch(updateDcddUserStatus(userID,status)),
});

export default connect(null, mapDispatchToProps)(HandleUpdateDcddStatus);
